import { Card } from './card';
import { Checkbox } from './checkbox';
import { CloseButton } from './close-button';
import { FormLabel } from './form';
import { Menu } from './menu';
import { Modal } from './modal';
import { Radio } from './radio';
import { Table } from './table';

export const components = {
	Card,
	Checkbox,
	CloseButton,
	FormLabel,
	Menu,
	Modal,
	Radio,
	Table,
};
